import React from 'react'
import { ToastContainer } from 'react-toastify';

const Dashboard = () => {
    return (
        <div>
            <ToastContainer />
        </div>
    )
}

export default Dashboard